var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.vvfield,{tag:"component",attrs:{"label":_vm.label,"placeholder":_vm.moneyPlaceholder,"rules":_vm.reg,"name":_vm.model,"min":_vm.min,"max":_vm.max},model:{value:(_vm.col),callback:function ($$v) {_vm.col=$$v},expression:"col"}})
}
var staticRenderFns = []

export { render, staticRenderFns }